/**
 * Version information for dungeo
 * Auto-generated by build.sh - DO NOT EDIT
 */
export const STORY_VERSION = '0.9.102';
export const BUILD_DATE = '2026-04-03T16:22:57Z';
export const ENGINE_VERSION = '0.9.102';
export const VERSION_INFO = { version: STORY_VERSION, buildDate: BUILD_DATE, engineVersion: ENGINE_VERSION } as const;
